export default {}

export const SET_AUTH = "SET_AUTH"
export const PURGE_AUTH = "PURGE_AUTH"
export const SET_ERROR = "SET_ERROR"
export const UPDATE_USER_ACCOUNT_STATUS = "UPDATE_USER_ACCOUNT_STATUS"
export const SET_CHOSEN_ACCOUNT = "SET_CHOSEN_ACCOUNT"
export const SET_SUBACCOUNTS = "SET_SUBACCOUNTS"
export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_ACCOUNTS = "UPDATE_ACCOUNTS"
export const EDIT_EMAIL = "EDIT_EMAIL"
export const EMAIL_CHANGE_CONFIRMATION = "EMAIL_CHANGE_CONFIRMATION"
export const EDIT_USER_EMAIL = "EDIT_USER_EMAIL"
export const UPDATE_PRIVACY = "UPDATE_PRIVACY"
export const UPDATE_LANGUAGE_CHANGED_ON_SIGN_UP =
  "UPDATE_LANGUAGE_CHANGED_ON_SIGN_UP"
export const INTEGRATIONS = "INTEGRATIONS"
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE"
export const UPDATE_UNITS = "UPDATE_UNITS"
export const UPDATE_SYSTEM_PRIVACY = "UPDATE_SYSTEM_PRIVACY"

// CALENDAR
export const SET_CALENDAR_EVENTS = "SET_EVENTS"
export const FILTER_CALENDAR_EVENTS = "FILTER_EVENTS"
export const CHANGE_CALENDAR_SESSION_TYPES = "CHANGE_CALENDAR_SESSION_TYPES"
export const UPDATE_PREVIEW_MODE = "UPDATE_PREVIEW_MODE"
export const UPDATE_FILTER_DATA_FROM_STORAGE = "UPDATE_FILTER_DATA_FROM_STORAGE"
export const UPDATE_VIEW_DATE = "UPDATE_VIEW_DATE"
export const RESET_STATE = "RESET_STATE"

// CALENDAR ACTIVITY
export const SET_CALENDAR_ACTIVITY = "SET_CALENDAR_ACTIVITY"
export const UPDATE_CALENDAR_ACTIVITY_METRIC = "UPDATE_CALENDAR_ACTIVITY_METRIC"
export const UPDATE_HR_SELECTED_UNIT = "UPDATE_HR_SELECTED_UNIT"
export const UPDATE_AVG_HR_SELECTED_UNIT = "UPDATE_AVG_HR_SELECTED_UNIT"
export const UPDATE_TOP_HR_SELECTED_UNIT = "UPDATE_TOP_HR_SELECTED_UNIT"
export const UPDATE_AP_ZONES_SELECTED_UNIT = "UPDATE_AP_ZONES_SELECTED_UNIT"
export const UPDATE_WORKLOAD_ZONES_SELECTED_UNIT =
  "UPDATE_WORKLOAD_ZONES_SELECTED_UNIT"
export const UPDATE_DISTANCE_ZONES_SELECTED_UNIT =
  "UPDATE_DISTANCE_ZONES_SELECTED_UNIT"
export const UPDATE_HR_CHART_UNIT = "UPDATE_HR_CHART_UNIT"
export const UPDATE_DISTANCE_CHART_UNIT = "UPDATE_DISTANCE_CHART_UNIT"
export const UPDATE_LIST_OF_CALENDAR_TEAMS = "UPDATE_LIST_OF_CALENDAR_TEAMS"
export const UPDATE_LIST_OF_SELECTED_CALENDAR_TEAMS =
  "UPDATE_LIST_OF_SELECTED_CALENDAR_TEAMS"
export const UPDATE_ACTIVITY_ATTACHMENTS = "UPDATE_ACTIVITY_ATTACHMENTS"
export const DELETE_ACTIVITY_ATTACHMENT = "DELETE_ACTIVITY_ATTACHMENT"
export const UPDATE_ACTIVITY_DESCRIPTION = "UPDATE_ACTIVITY_DESCRIPTION"
export const DELETE_ACTIVITY = "DELETE_ACTIVITY"
export const DESTROY_ACTIVITY_DATA = "DESTROY_ACTIVITY_DATA"
export const UPDATE_CALENDAR_STORAGE = "UPDATE_CALENDAR_STORAGE"
export const UPDATE_ACTIVITY_SELECTIONS = "UPDATE_ACTIVITY_SELECTIONS"
export const ADD_ACTIVITY_SEGMENT = "ADD_ACTIVITY_SEGMENT"
export const DELETE_ACTIVITY_SEGMENT = "DELETE_ACTIVITY_SEGMENT"
export const ADD_TO_FILTERED_SEGMENT = "ADD_TO_FILTERED_SEGMENT"
export const REMOVE_FROM_FILTERED_SEGMENT = "REMOVE_FROM_FILTERED_SEGMENT"
export const SELECT_DESELECT_ALL_SEGMENT = "SELECT_DESELECT_ALL_SEGMENT"
export const UPDATE_SELECTED_SEGMENT_STATS_TABLE =
  "UPDATE_SELECTED_SEGMENT_STATS_TABLE"
export const UPDATE_STATS_TABLE_SEGMENT = "FETCH_STATS_TABLE_SEGMENT"
export const UPDATE_LIST_OF_STATS_SEGMENTS = "UPDATE_LIST_OF_STATS_SEGMENTS"
export const CALENDAR_ACTIVITY_NOT_FOUND = "CALENDAR_ACTIVITY_NOT_FOUND"
export const CALENDAR_ACTIVITY_DELETED = "CALENDAR_ACTIVITY_DELETED"
export const FETCH_TIMELINE_CHART_DATA = "FETCH_TIMELINE_CHART_DATA"

//SESSION HISTORY
export const SET_SESSION_HISTORY_DATA = "SET_SESSION_HISTORY_DATA"
export const UPDATE_MORE_PRECISE_ACTIVITY_DATA =
  "UPDATE_MORE_PRECISE_ACTIVITY_DATA"

// TEAMS
export const UPDATE_TEAMS = "UPDATE_TEAMS"

// DASHBOARD
export const UPDATE_TIME_ABOVE_80_PERCENT_HR = "UPDATE_TIME_ABOVE_80_PERCENT_HR"
export const UPDATE_AP = "UPDATE_AP"
export const UPDATE_DISTANCE = "UPDATE_DISTANCE"
export const UPDATE_WORKLOAD = "UPDATE_WORKLOAD"
export const UPDATE_SELECTED_TEAM = "UPDATE_SELECTED_TEAM"
export const UPDATE_SELECTED_ENTITY = "UPDATE_SELECTED_ENTITY"
export const UPDATE_TIMERANGE = "UPDATE_TIMERANGE"
export const UPDATE_SELECTED_METRIC = "UPDATE_SELECTED_METRIC"
export const UPDATE_TEAM_DATA = "UPDATE_TEAM_DATA"
export const UPDATE_TIMELINE = "UPDATE_TIMELINE"
export const UPDATE_INDIVIDUAL_TIMELINE = "UPDATE_INDIVIDUAL_TIMELINE"
export const UPDATE_ALL_TEAMS_TIMELINE = "UPDATE_ALL_TEAMS_TIMELINE"
export const UPDATE_SELECTED_DASHBOARD = "UPDATE_SELECTED_DASHBOARD"
export const UPDATE_TIMERANGE_TO_DATE = "UPDATE_TIMERANGE_TO_DATE"
export const UPDATE_TIMERANGE_FROM_DATE = "UPDATE_TIMERANGE_FROM_DATE"
export const UPDATE_INDIVIDUAL_DASHBOARD = "UPDATE_INDIVIDUAL_DASHBOARD"
export const UPDATE_ALL_TEAMS_DASHBOARD = "UPDATE_ALL_TEAMS_DASHBOARD"
export const RESET_DASHBOARD_STATE = "RESET_DASHBOARD_STATE"
export const UPDATE_DASHBOARD_NO_DATA = "UPDATE_DASHBOARD_NO_DATA"
export const UPDATE_INITIAL_DATA_FETCHED = "UPDATE_INITIAL_DATA_FETCHED"
export const GO_TO_NEXT_PAGE = "GO_TO_NEXT_PAGE"
export const GO_TO_PREVIOUS_PAGE = "GO_TO_PREVIOUS_PAGE"
export const UPDATE_LAST_SESSION_DATA = "UPDATE_LAST_SESSION_DATA"
export const RESET_TIMELINE_STATE = "RESET_TIMELINE_STATE"

//ADDITIONAL EMAIL
export const SET_ADDITIONAL_EMAIL = "SET_ADDITIONAL_EMAIL"
export const REMOVE_ADDITIONAL_EMAIL = "REMOVE_ADDITIONAL_EMAIL"

export const UPDATE_NO_SESSIONS = "UPDATE_NO_SESSIONS"

// LEADERBOARD
export const UPDATE_LEADERBOARD_DATA = "UPDATE_LEADERBOARD_DATA"
export const UPDATE_LEADERBOARD_TEAM_INDIVIDUAL =
  "UPDATE_LEADERBOARD_TEAM_INDIVIDUAL"
export const UPDATE_LEADERBOARD_SCOPE = "UPDATE_LEADERBOARD_SCOPE"
export const UPDATE_LEADERBOARD_AGREGATION_METHOD =
  "UPDATE_LEADERBOARD_AGREGATION_METHOD"
export const UPDATE_LEADERBOARD_SORT = "UPDATE_LEADERBOARD_SORT"
export const UPDATE_LEADERBOARD_FILTER = "UPDATE_LEADERBOARD_FILTER"
export const UPDATE_LEADERBOARD_TEAMS = "UPDATE_LEADERBOARD_TEAMS"
export const SELECT_LEADERBOARD_TEAM = "SELECT_LEADERBOARD_TEAM"
export const UPDATE_LEADERBOARD_TIME_FRAME = "UPDATE_LEADERBOARD_TIME_FRAME"
export const UPDATE_NO_DATA_FLAG = "UPDATE_NO_DATA_FLAG"
export const DESTROY_LEADERBOARD_DATA = "DESTROY_LEADERBOARD_DATA"

export const SET_PLAYER_POSITIONS = "SET_PLAYER_POSITIONS"
